<div class="d-flex h-100 w-100 align-items-center justify-content-center">
  <div
    class="d-flex align-items-center justify-content-center rounded shadow p-4 bg-white"
  >
    <i class="la la-spin la-cog la-2x ml-2"></i>
    <div class="ml-2">{{ "navigations.loading" | translate }}</div>
  </div>
</div>
